import {abstractDefaultFilter} from './../abstractDefaultFilter';

function F() {
    return (F.is(this) ? this.init : F.F).apply(this, Array.prototype.slice.call(arguments));
}

var P = F.leu_extend(abstractDefaultFilter).prototype;

// eslint-disable-next-line
P.get_default = function (current_value, params, field_name) {
    if (params.has_param('default')) {
        var val = params.get_param('default').value;
        if (typeof (val) === 'string') {
            return val;
        }
    }
    return '';
};

export default F;


